/// <reference path='../../typings/browser.d.ts' />
/// <reference path='../../customtypings/angular-peity/angular-peity.d.ts' />
/// <reference path="../../customtypings/jquery.flot/jquery.flot.d.ts" />

namespace Application.Directives {
    'use strict';

    import TrendingInfo = Application.Models.TrendingInfo;
    import ThumbnailRetriever = Application.Models.ThumbnailRetriever;
    import VideoFeedStatus = Application.Models.VideoFeedStatus;
    import MonitorStatus = Application.Models.MonitorStatus;
    import IBlock = Application.Models.IBlock;
    import IRedundantBlocks = Application.Models.IRedundantBlocks;
    import VideoFeed = Application.Models.VideoFeed;
    import VideoFeedService = Application.Services.VideoFeedService;

    declare type GridMonitorDirectiveCb = ($interval: angular.IIntervalService,
                                           $timeout: angular.ITimeoutService,
                                           $location: ng.ILocationService,
                                           streamStatusService: Services.StreamStatusService,
                                           streamPipeService: Services.StreamPipeService,
                                           connectionRoomService: Services.ConnectionRoomService,
                                           modalService: ngModal.IModalService,
                                           networkNodeService: Services.NetworkNodeService,
                                           $q: ng.IQService,
                                           alarmsService: Services.AlarmsService,
                                           stompService: Services.StompService,
                                           videoFeedService: Services.VideoFeedService,
                                           healthService: Services.HealthService,
                                           $cookies: ng.cookies.ICookiesService,
                                           timezoneService: Services.TimezoneService,
                                           flexCollectorService: Services.FlexCollectorService,
                                           $rootScope: Services.IFlexSettings,
                                           $http: ng.IHttpService,
                                           blockService: Services.BlockService) => GridMonitorDirective;


    export interface IGridMonitorScopeDef {
        model: string;
        showTrending: string;
        id: string;
        showAlarms: string;
        plotOptions: string;
    }

    export interface IGridMonitorScope extends ng.IScope {
        model: Models.IMonitor;
        showTrending: boolean;
        id: string;
        showAlarms: string;

        trafficStyleReady: boolean;
        plot: jquery.flot.plot;
        plotOptions: any;
        showHistoricalTraffic: () => void;
        loadStreamData: () => void;
        seeStream: () => void;
        bulkConfirm: () => void;
        initIntervals: () => void;
        getContentStyle: () => Object;
        getGraphStyle: () => Object;
        monitorStatus: string;
        dataStatus: Models.IStreamStatus;
        streamPipe: Models.IStreamPipe;
        thumbnail: string;
        thumbnailError: boolean;
        thumbnailErrorBackend: boolean;
        thumbnailRetriever: ThumbnailRetriever;
        videoFeed: Models.IVideoFeed;
        serviceInfo: IServiceInfo;
        streamId: number;
        trendingInfo: Models.TrendingInfo;
        sourceNode: Models.NetworkNode;
        sinkNode: Models.NetworkNode;
        stompSubs: Services.IEventSubscription[];
        streamDataTimerPromise: angular.IPromise<void>;
        monitorInfoLabel: string;
        trendingHeight: string;
        thumbnailLoaded: boolean;
        watchers: Function[];
        requestTrending: boolean;
        videoFeedCycleCount: number;
        streamDataTimer: number;
        videoFeedInterval: ng.IPromise<void>;
        srtInPipe: string[];
        bulkDebounce: boolean;
        loadingTimeout: ng.IPromise<void>;
        stompReconnectUnsubscribe: Function;
        windowWidthUnsubscribe: Function;
    }

    export class GridMonitorDirective implements ng.IDirective {
        public static $name: string = 'gridMonitor';
        public static $inject: string[] = [];

        private static THUMBNAIL_LOADING_IMG: string = 'images/thumbnail-loading.png';
        private static THUMBNAIL_GREY_IMG: string = 'images/thumbnail-grey.png';
        private static THUMBNAIL_SRC_MISMATCH_IMG: string = 'images/thumbnail-source-mismatch.png';
        private static MAX_GRAPH_SECONDS: number = 90;
        private static LOADING_TIMEOUT: number = 10000;
        private static LOADING_DELAY: number = 16000;
        private static THUMBNAIL_PATH: string = 'thumbnail/block/';

        public link: (scope: IGridMonitorScope, element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'E';
        public transclude: boolean = false;
        public replace: boolean = true;
        public templateUrl: string = 'decorators/grid-monitor-directive.html';

        public scope: IGridMonitorScopeDef = {
            model: '=',
            showTrending: '=',
            id: '=',
            showAlarms: '=',
            plotOptions: '=',
        };

        public static Factory(): GridMonitorDirectiveCb {
            let directive: GridMonitorDirectiveCb = ($interval: angular.IIntervalService,
                                                     $timeout: angular.ITimeoutService,
                                                     $location: ng.ILocationService,
                                                     streamStatusService: Services.StreamStatusService,
                                                     streamPipeService: Services.StreamPipeService,
                                                     connectionRoomService: Services.ConnectionRoomService,
                                                     modalService: ngModal.IModalService,
                                                     networkNodeService: Services.NetworkNodeService,
                                                     $q: ng.IQService,
                                                     alarmsService: Services.AlarmsService,
                                                     stompService: Services.StompService,
                                                     videoFeedService: Services.VideoFeedService,
                                                     healthService: Services.HealthService,
                                                     $cookies: ng.cookies.ICookiesService,
                                                     timezoneService: Services.TimezoneService,
                                                     flexCollectorService: Services.FlexCollectorService,
                                                     $rootScope: Services.IFlexSettings,
                                                     $http: ng.IHttpService,
                                                     blockService: Services.BlockService) => {
                return new GridMonitorDirective($interval,
                    $timeout,
                    $location,
                    streamStatusService,
                    streamPipeService,
                    connectionRoomService,
                    modalService,
                    networkNodeService,
                    $q,
                    alarmsService,
                    stompService,
                    videoFeedService,
                    healthService,
                    $cookies,
                    timezoneService,
                    flexCollectorService,
                    $rootScope,
                    $http,
                    blockService);
            };

            directive.$inject = ['$interval',
                '$timeout',
                '$location',
                'streamStatusService',
                'streamPipeService',
                'connectionRoomService',
                'ModalService',
                'networkNodeService',
                '$q',
                'alarmsService',
                'stompService',
                'videoFeedService',
                'healthService',
                '$cookies',
                'timezoneService',
                'flexCollectorService',
                '$rootScope',
                '$http',
                'blockService',
            ];

            return directive;
        }

        constructor(private $interval: angular.IIntervalService,
                    private $timeout: angular.ITimeoutService,
                    private $location: ng.ILocationService,
                    private streamStatusService: Services.StreamStatusService,
                    private streamPipeService: Services.StreamPipeService,
                    private connectionRoomService: Services.ConnectionRoomService,
                    private modalService: ngModal.IModalService,
                    private networkNodeService: Services.NetworkNodeService,
                    private $q: ng.IQService,
                    private alarmsService: Services.AlarmsService,
                    private stompService: Services.StompService,
                    private videoFeedService: Services.VideoFeedService,
                    private healthService: Services.HealthService,
                    private $cookies: ng.cookies.ICookiesService,
                    private timezoneService: Services.TimezoneService,
                    private flexCollectorService: Services.FlexCollectorService,
                    private $rootScope: Services.IFlexSettings,
                    private $http: ng.IHttpService,
                    private blockService: Services.BlockService
        ) {
            GridMonitorDirective.prototype.link = async (scope: IGridMonitorScope, element: JQuery) => {
                scope.plotOptions = {
                    layout: {
                        padding: {
                            top: 10,
                        }
                    }
                };

                this.initData(scope);
                this.initBindings(scope, element);
                await this.initTrending(scope);
                await this.reloadThumbnail(scope);

                scope.seeStream = () => {
                    if (scope.streamId) {
                        $location.path('/stream/' + scope.streamId);
                    }
                };

                scope.bulkConfirm = async () => {
                    let promises: ng.IPromise<{}>[] = [];
                    let extraNames: string[] = [];
                    if (Common.Utils.exists(scope.streamPipe) &&
                        (scope.model.monitorGrid.sink || (scope.model.monitorGrid.source && scope.model.monitorGrid.sink))) {
                        scope.srtInPipe = scope.srtInPipe || await this.streamPipeService.getSrtInPipe(scope.streamPipe);
                        const nodeSrtInPipe: string[] = scope.srtInPipe.filter((href) => {
                            return href.indexOf('networkNodes/') > -1
                        });
                        for (let href of nodeSrtInPipe) { //To display node name in modal
                            extraNames.push((await this.networkNodeService.getByIdPromise(Common.Utils.idFromHref(href))).name);
                        }
                    }
                    if (scope.model.monitorGrid.sinkNode) {
                        promises.push(this.networkNodeService.getByIdPromise(Common.Utils.idFromHref(scope.model.monitorGrid.sinkNode)));
                    }
                    if (Common.Utils.exists(scope.model.monitorGrid.sourceNode)) {
                        promises.push(this.networkNodeService.getByIdPromise(Common.Utils.idFromHref(scope.model.monitorGrid.sourceNode)));
                    } else if (Common.Utils.exists(scope.streamPipe) && Common.Utils.exists(scope.streamPipe.sourceNodeHref)) {
                        promises.push(this.networkNodeService.getByIdPromise(Common.Utils.idFromHref(scope.streamPipe.sourceNodeHref)));
                    }

                    this.$q.all(promises).then((res: Models.INetworkNode[]) => {
                        modalService.showModal({
                            templateUrl: Controllers.AcknowledgeAllModalController.templateURL,
                            controller: Controllers.AcknowledgeAllModalController.$name,
                            inputs: {
                                monitorName: scope.model.name,
                                sourceName: res[1] ? res[1].name : undefined,
                                sinkName: res[0].name,
                                extraNames: extraNames,
                            },
                        }).then((modal: ngModal.IModalObject) => {
                            let acknowledgeModalElem: UIkit.ModalElement = UIkit.modal(Controllers.AcknowledgeAllModalController.ID,
                                {bgclose: false, modal: false, keyboard: false});
                            acknowledgeModalElem.show();
                            modal.close.then((result: string) => {
                                acknowledgeModalElem.hide();
                                if (result !== undefined) {
                                    let srcBlockSimplHref: string;
                                    let srcSimplHref: string;
                                    if (Common.Utils.exists(scope.model.monitorGrid.source)) {
                                        srcBlockSimplHref = 'blocks/' + scope.model.monitorGrid.source;
                                        srcSimplHref = 'networkNodes/' + scope.model.monitorGrid.sourceNode;
                                    } else if (Common.Utils.exists(scope.model.streamPipe) &&
                                        Common.Utils.exists(scope.model.streamPipe.sourceBlockId)) {
                                        srcBlockSimplHref = 'blocks/' + scope.model.streamPipe.sourceBlockId;
                                        srcSimplHref = 'networkNodes/' + scope.model.streamPipe.sourceNodeHref;
                                    }

                                    let snkBlockSimplHref: string = undefined;
                                    let snkSimplHref: string;
                                    if (Common.Utils.exists(scope.model.monitorGrid.sink)) {
                                        snkBlockSimplHref = 'blocks/' + scope.model.monitorGrid.sink;
                                        snkSimplHref = 'networkNodes/' + scope.model.monitorGrid.sinkNode;
                                    }

                                    let mssg: string = result !== '' ? result : 'Bulk confirm';
                                    alarmsService.confirmEveryAlarmForDevices(srcBlockSimplHref, snkBlockSimplHref, mssg);
                                    alarmsService.confirmEveryAlarmForDevices(srcSimplHref, snkSimplHref, mssg);
                                    scope.srtInPipe.forEach((srt: string) => {
                                        alarmsService.confirmEveryAlarmForDevices(srt, undefined, mssg);
                                    });
                                }
                            });
                        });
                    });
                };

                scope.getContentStyle = (): Object => {
                    scope.trendingHeight = Math.floor(this.calculateTrendingHeight()) + 'px';

                    let container: JQuery = $('.grid-thumb-monitor-wrapper').parent();
                    let width: number = container.width();
                    let height: number = container.height();
                    let aR: number = 16 / 9;
                    let monitorWidth: number;
                    let monitorHeight: number;
                    let monitorTop: number = 0;
                    let monitorLeft: number = 0;
                    if (width / height > aR) {
                        monitorWidth = height * aR;
                        monitorHeight = height;
                        monitorLeft = (width - monitorWidth) / 2;
                    } else {
                        monitorWidth = width;
                        monitorHeight = width / aR;
                        monitorTop = (height - monitorHeight) / 2;
                    }
                    if (scope.showTrending === true) {
                        monitorTop = 0;
                        $('.monitor-bottom-bar').css({'bottom': scope.trendingHeight});
                    } else {
                        $('.monitor-bottom-bar').css({'bottom': '0'});
                    }
                    return {
                        'width': `${Math.floor(monitorWidth)}px`,
                        'height': `${Math.floor(monitorHeight)}px`,
                        'position': 'relative',
                        'top': `${Math.floor(monitorTop)}px`,
                        'left': `${Math.floor(monitorLeft)}px`,
                    };
                };

                scope.getGraphStyle = (): Object => {
                    scope.trafficStyleReady = true;
                    return {
                        'top': `-${scope.trendingHeight}`,
                        'height': `${scope.trendingHeight}`,
                    };
                };

                scope.showHistoricalTraffic = () => {
                    if (scope.model.streamPipe !== undefined && !!scope.model.streamPipe.href) {
                        $location.path('/historical/' + Common.Utils.idFromHref(scope.model.streamPipe.href));
                    }
                };
            };
        }

        /**
         * Method to do the initial loading of data by dummy values
         *
         * @param scope {IGridMonitorScope}
         */
        private initData(scope: IGridMonitorScope): void {
            // initial monitor adjustment when trending graph is ON
            if (scope.showTrending === true) {
                $('.monitor-bottom-bar').css({'bottom': '100px'});
            }

            // dummy data init
            scope.monitorStatus = MonitorStatus.PENDING;
            scope.monitorInfoLabel = '';
            if (scope.thumbnail === undefined) {
                scope.thumbnail = GridMonitorDirective.THUMBNAIL_LOADING_IMG;
                scope.thumbnailError = false;
                scope.thumbnailErrorBackend = false;
                scope.loadingTimeout = this.$timeout(() => {
                    if (!scope.videoFeed || scope.videoFeed.status === VideoFeedStatus.OK) {
                        // we have to add the thumbnail request in the backend map thumbRequestsMap to avoid the thumbnail grey error in mvp cases
                        const blockId: number = scope.model.monitorGrid.sink ? Number(scope.model.monitorGrid.sink) : Number(scope.model.monitorGrid.source);
                        scope.thumbnail = GridMonitorDirective.THUMBNAIL_GREY_IMG;
                        scope.thumbnailError = true;
                        this.$http.post(window.backendUrl + "mvpadapter/" + GridMonitorDirective.THUMBNAIL_PATH +  blockId.toString() + "/videofeed", blockId);
                    }
                }, GridMonitorDirective.LOADING_TIMEOUT);
            }
            if (scope.model !== undefined && scope.model.source !== undefined && scope.model.source !== '') {
                scope.streamId = Common.Utils.idFromHref(scope.model.source);
            } else {
                scope.streamId = undefined;
                scope.streamPipe = undefined;
                scope.serviceInfo = undefined;
            }

            if (scope.trendingInfo) {
                scope.trendingInfo.close();
                scope.trendingInfo = undefined;
            }
            this.calculateStreamDataTimer(scope);
        }

        /**
         * Method to check the status of the scope params and init the monitor status in case is needed
         *
         * @param scope {IGridMonitorScope} needed to check if there is streamId,
         * otherwise checks the monitorGrid sink and source name in order to invoke or not setMonitorStatus method
         */
        private async initTrending(scope: IGridMonitorScope): Promise<void> {
            await this.getData(scope);
            if (!scope.streamId &&
                (scope.model.monitorGrid.sinkName !== undefined || scope.model.monitorGrid.sourceName !== undefined)) {
                this.setMonitorStatus(scope);
            }
        }

        /**
         * Method to initialize the videoFeed param in the scope
         *
         * @param scope {IGridMonitorScope} in case that it has the data needed it will store it in videoFeed
         * otherwise it will call the method videoFeedHasChanged
         */
        private async initVideoFeed(scope: IGridMonitorScope): Promise<void> {
            if (!scope.videoFeed && scope.model.monitorGrid && scope.model.monitorGrid.videoFeed) {
                scope.videoFeed = scope.model.monitorGrid.videoFeed;
            } else {
                await this.videoFeedHasChanged(scope);
            }
        }

        /**
         * Method in charge of updating or creating a new Thumbnail subscription
         *
         * @param scope {IGridMonitorScope} if scope.thumbnailRetriever will update it otherwise it will create a new one
         */
        private subscribeToThumbnails(scope: IGridMonitorScope): void {
            if (scope.thumbnailRetriever) {
                scope.thumbnailRetriever.close();
                scope.thumbnailRetriever.thumbnail.url = undefined;
                scope.thumbnailRetriever.initThumbnailSubscription();
            } else {
                const blockId: number = scope.model.monitorGrid.sink ?
                    Number(scope.model.monitorGrid.sink) :
                    Number(scope.model.monitorGrid.source);
                scope.thumbnailRetriever = new ThumbnailRetriever(this.stompService, this.$timeout, blockId);
                scope.thumbnailRetriever.onThumbnail((data: string, url: string, failedThumbnail: boolean) => {
                    if (url !== '') {
                        if (scope.videoFeed.blockTypeNaturalKey === Application.Models.BlockTypeNaturalKey.MVP_CLIENT ||
                            scope.videoFeed.blockTypeNaturalKey === Application.Models.BlockTypeNaturalKey.MVP_PLAYOUT ||
                            scope.videoFeed.blockTypeNaturalKey === Application.Models.BlockTypeNaturalKey.MVP_EXPORT ||
                            scope.videoFeed.blockTypeNaturalKey === Application.Models.BlockTypeNaturalKey.MVP_SERVER) {
                            scope.thumbnailRetriever.thumbnail.url = window.backendUrl + "mvpadapter" + url + '?t=' + Common.Utils.getCurrentTimestamp();
                        } else {
                            scope.thumbnailRetriever.thumbnail.url = window.backendUrl + url + '?t=' + Common.Utils.getCurrentTimestamp();
                        }
                    } else {
                        if (scope.videoFeed.status === VideoFeedStatus.OFFLINE) {
                            scope.thumbnailRetriever.thumbnail.url = 'images/thumbnail-offline.png?';
                        } else if (scope.videoFeed.status === VideoFeedStatus.SERVER_NOT_AVAILABLE) {
                            scope.thumbnailRetriever.thumbnail.url = 'images/thumbnail-server-not-available.png?';
                        } else if (scope.videoFeed.status === VideoFeedStatus.CONNECTING) {
                            if (scope.videoFeed.position === Application.Models.PipePosition.SINK) {
                                scope.thumbnailRetriever.thumbnail.url = 'images/thumbnail-playout-idle.png?';
                            } else {
                                scope.thumbnailRetriever.thumbnail.url = 'images/thumbnail-connecting.png?';
                            }
                        } else if (scope.videoFeed.status === VideoFeedStatus.DISCONNECTING) {
                            if (scope.videoFeed.position === Application.Models.PipePosition.SINK) {
                                scope.thumbnailRetriever.thumbnail.url = 'images/thumbnail-playout-idle.png?';
                            } else {
                                scope.thumbnailRetriever.thumbnail.url = 'images/thumbnail-disconnecting.png?';
                            }
                        } else if (scope.videoFeed.status === VideoFeedStatus.READY) {

                            if (scope.videoFeed.position === Application.Models.PipePosition.SINK) {
                                if (scope.videoFeed.blockTypeNaturalKey === Application.Models.BlockTypeNaturalKey.ATEME_DR5000) {
                                    // because we want to monitor this even if device is not connected.
                                    scope.thumbnailRetriever.thumbnail.url = window.backendUrl
                                        + '/thumbnail/device/' + blockId + '/' + url + '?t=' + Common.Utils.getCurrentTimestamp();
                                }else if (scope.videoFeed.blockTypeNaturalKey === Application.Models.BlockTypeNaturalKey.MEDIAKIND_RX8200) {
                                    scope.thumbnailRetriever.thumbnail.url = 'images/thumbnail-ericsson-rx8200-idle.png?';
                                } else if (scope.videoFeed.blockTypeNaturalKey === Application.Models.BlockTypeNaturalKey.V_TS_DESTINATION) {
                                    scope.thumbnailRetriever.thumbnail.url = 'images/thumbnail-ts-idle.png';
                                } else if (scope.videoFeed.blockTypeNaturalKey === Application.Models.BlockTypeNaturalKey.SDI_DESTINATION) {
                                    scope.thumbnailRetriever.thumbnail.url = 'images/thumbnail-sdi-idle.png';
                                } else {
                                    scope.thumbnailRetriever.thumbnail.url =  'images/thumbnail-playout-idle.png?';
                                }
                            } else {
                                if (scope.videoFeed.blockTypeNaturalKey === Application.Models.BlockTypeNaturalKey.ATEME_CM5000) {
                                    // because we want to monitor this even if device is not connected.
                                    scope.thumbnailRetriever.thumbnail.url = window.backendUrl
                                        + '/thumbnail/device/' + blockId + '/' + url + '?t=' + Common.Utils.getCurrentTimestamp();
                                } else if (scope.videoFeed.blockTypeNaturalKey === Application.Models.BlockTypeNaturalKey.V_TS) {
                                    scope.thumbnailRetriever.thumbnail.url = 'images/thumbnail-ts-idle.png?';
                                } else if (scope.videoFeed.blockTypeNaturalKey === Application.Models.BlockTypeNaturalKey.SDI_DESTINATION) {
                                    scope.thumbnailRetriever.thumbnail.url = 'images/thumbnail-sdi-idle.png';
                                }  else {
                                    scope.thumbnailRetriever.thumbnail.url = 'images/thumbnail-ready.png?';
                                }
                            }

                        } else if (scope.videoFeed.status === VideoFeedStatus.OK) {
                            scope.thumbnailRetriever.thumbnail.url = window.backendUrl
                                + '/thumbnail/device/' + blockId + '/' + url + '?t=' + Common.Utils.getCurrentTimestamp();
                        }
                    }
                    if (scope.loadingTimeout) {
                        scope.thumbnailError = false;
                        scope.thumbnailErrorBackend = failedThumbnail;
                        this.$timeout.cancel(scope.loadingTimeout);
                        scope.loadingTimeout = this.$timeout(() => {
                            if (!scope.videoFeed || scope.videoFeed.status === VideoFeedStatus.OK) {
                                scope.thumbnail = GridMonitorDirective.THUMBNAIL_GREY_IMG;
                                scope.thumbnailError = true;
                                scope.thumbnailErrorBackend = false;
                            }
                        }, GridMonitorDirective.LOADING_DELAY);
                    }
                });
            }
        }

        /**
         * Method to unsubscribe from stompService, this method is called while 'destroy'
         *
         * @param scope {IGridMonitorScope}
         */
        private unsubscribeToThumbnails(scope: IGridMonitorScope): void {
            if (scope.thumbnailRetriever) {
                scope.thumbnailRetriever.close();
                scope.thumbnailRetriever.thumbnail.url = undefined;
            }
        }

        /**
         * Method to set or cancel the video feed interval, this is called when the stompService triggers:
         *  - PROBE_OPERATION
         *  - UNPROBE_OPERATION
         *  - TAKE_OPERATION
         *  - DROP_OPERATION
         *  - HEALTH_CHANGED
         *
         * @param scope {IGridMonitorScope} if already exists videoFeedInterval in the scope it will cancel the interval.
         * If no videoFeedInterval it will try to subscribeToThumbnails and if fails it cancels the interval.
         */
        private initVideoFeedInterval(scope: IGridMonitorScope): void {
            if (scope.videoFeedInterval) {
                this.$interval.cancel(scope.videoFeedInterval);
            }
            scope.videoFeedCycleCount = 5;
            scope.videoFeedInterval = this.$interval(async () => {
                if (scope.videoFeedCycleCount <= 0) {
                    this.$interval.cancel(scope.videoFeedInterval);
                }
                if (await this.videoFeedHasChanged(scope)) {
                    this.subscribeToThumbnails(scope);
                }
                scope.videoFeedCycleCount--;
            }, scope.streamDataTimer);
        }

        /**
         * Method to centralize the calling to get MonitorData and to set the status of the monitors.
         *
         * @param scope {IGridMonitorScope} in case that we have streamId but not streamPipe data int the scope it will
         * await for getting it from getStreamPipe
         */
        private async getData(scope: IGridMonitorScope): Promise<void> {
            if (!scope.streamId) {
                await this.getMonitorData(scope);
                return;
            }
            // stream pipe basic information (one time call)
            if (!scope.streamPipe) {
                const streamHref: string = scope.streamId.toString();
                const streamPipe: Models.IStreamPipe = await this.streamPipeService.getStreamPipe(streamHref, false) as Models.IStreamPipe;
                scope.streamPipe = streamPipe;
                scope.model.streamPipe = streamPipe;
            }
            await this.getMonitorData(scope);
        }

        /**
         * Method to retrieve all the data displayed in the monitor:
         *  - thumbnail (only if videoFeedHasChanged)
         *  - trending data
         *  - status data
         *
         * @param scope {IGridMonitorScope}
         */
        private async getMonitorData(scope: IGridMonitorScope): Promise<void> {
            if (await this.videoFeedHasChanged(scope)) {
                await this.reloadThumbnail(scope);
                scope.thumbnail = this.getThumbnailUrl(scope);
            }
            this.getTrendingData(scope);
            this.setMonitorStatus(scope);
        }

        /**
         * Method to get, in case we don't have it yet the trendingInfo and store it in the scope
         *
         * @param scope {IGridMonitorScope} needed to check if we already have ot and if not to store it
         */
        private async getTrendingData(scope: IGridMonitorScope): Promise<void> {
            if (scope !== undefined && !scope.trendingInfo) {
                let blockId: number = scope.model.monitorGrid.sink as number;
                if (!Common.Utils.exists(scope.model.monitorGrid.sink))
                    blockId = scope.model.monitorGrid.source as number;
                if (scope.model.monitorGrid.sink !== null ) {
                    const sinkBlock: IBlock = scope.model.monitorGrid.sinkBlock;
                    // check if the sink of the monitor is a secondary block of a DR5000, and in that case,
                    // find the primary block and use it to show the bitrate properly
                    if (sinkBlock.config.isRedundant !== null && sinkBlock.config.isRedundant) {
                        const blocksInNode: IBlock[] = await this.blockService.blocksInNode(Number(sinkBlock.networkNodeHref));
                        const primarytBlockInNode: IBlock = blocksInNode.filter( (x: IBlock) => !x.config.isRedundant)[0];
                        if(primarytBlockInNode !== undefined) {
                            const redundantBlocks: IRedundantBlocks = await this.blockService.getRedundantBlocks(primarytBlockInNode.id);
                            if (redundantBlocks.secondaryEncoderBlock !== null && redundantBlocks.secondaryDecoderBlock !== null) {
                                blockId = primarytBlockInNode.id;
                            }
                        }
                    }
                }

                scope.trendingInfo = new TrendingInfo(
                    this.streamStatusService, this.flexCollectorService, this.$timeout,
                    this.$q,
                    "blocks/" + blockId, GridMonitorDirective.MAX_GRAPH_SECONDS, scope.showTrending,
                    () => { this.setMonitorInfoLabel(scope);}, undefined
                );
                scope.trendingInfo.initTrendingData();
            }
        }

        /**
         * Method to set the status of the monitors.
         * Retrieves the data from sinkNode and sourceNode and check the healthStatus param value, it can be:
         *  - ONLINE
         *  - OFFLINE
         *  - PENDING
         *
         * @param scope {IGridMonitorScope} with the data needed to get healthStatus from sinkNode and sourceNode.
         */
        private setMonitorStatus(scope: IGridMonitorScope): void {
            if (scope.model && scope.model.monitorGrid) {
                let sourceHealth: string = undefined;
                let sinkHealth: string = undefined;

                if (Common.Utils.exists(scope.model.monitorGrid.sourceNode)) {
                    let sourceNodeHealth: Models.IDataNodeHealth =
                        this.healthService.getNetworkNodeHealth(scope.model.monitorGrid.sourceNode);
                    sourceHealth = sourceNodeHealth.data.healthStatus;
                }

                if (Common.Utils.exists(scope.model.monitorGrid.sinkNode)) {
                    let sinkNodeHealth: Models.IDataNodeHealth =
                        this.healthService.getNetworkNodeHealth(scope.model.monitorGrid.sinkNode);
                    sinkHealth = sinkNodeHealth.data.healthStatus;
                }

                if ((scope.videoFeed &&
                    ((scope.videoFeed.status === VideoFeedStatus.READY) || scope.videoFeed.status === VideoFeedStatus.OK)) ||
                    (scope.model.monitorGrid.sourceName !== undefined && scope.model.monitorGrid.sourceName !== null &&
                        scope.model.monitorGrid.sinkName !== undefined && scope.model.monitorGrid.sinkName !== null)) {
                    if (sourceHealth && sinkHealth) {
                        if (sourceHealth === MonitorStatus.OFFLINE || sinkHealth === MonitorStatus.OFFLINE) {
                            scope.monitorStatus = MonitorStatus.OFFLINE;
                        } else if (sourceHealth === MonitorStatus.ONLINE && sinkHealth === MonitorStatus.ONLINE) {
                            scope.monitorStatus = MonitorStatus.ONLINE;
                        } else {
                            scope.monitorStatus = MonitorStatus.PENDING;
                        }
                    } else if (sinkHealth) {
                        scope.monitorStatus = sinkHealth;
                    } else if (sourceHealth) {
                        scope.monitorStatus = sourceHealth;
                    }
                } else {    // not OK or only Source/Sink selected
                    if (scope.model.monitorGrid.sourceName !== undefined && scope.model.monitorGrid.sourceName !== null &&
                        (scope.model.monitorGrid.sinkName === undefined || scope.model.monitorGrid.sinkName === null)) {
                        // Only source monitor
                        scope.monitorStatus = sourceHealth ? sourceHealth : MonitorStatus.OFFLINE;
                    } else if (scope.model.monitorGrid.sinkName !== undefined && scope.model.monitorGrid.sinkName !== null &&
                        (scope.model.monitorGrid.sourceName === undefined || scope.model.monitorGrid.sourceName === null)) {
                        // Only sink monitor
                        scope.monitorStatus = sinkHealth ? sinkHealth : MonitorStatus.OFFLINE;
                    }
                }
                return;
            }
        }

        /**
         * Method to check if the video feed stored in the scope for the source or sink monitor
         * is the same than the one in the videoFeedService
         *
         * @param scope IGridMonitorScope with the information to be checked against the response from videoFeedService
         * @return Promise<boolean> true if has changed false otherwise
         */
        private async videoFeedHasChanged(scope: IGridMonitorScope): Promise<boolean> {
            if (scope.model && scope.model.monitorGrid) {
                const videoFeed: Models.VideoFeed = await this.videoFeedService.getVideoFeedByBlockId(scope.model.monitorGrid.sink ?
                    scope.model.monitorGrid.sink.toString() : scope.model.monitorGrid.source.toString());
                const hasChanged: boolean = !videoFeed.equals(scope.videoFeed);
                if (hasChanged) {
                    scope.videoFeed = videoFeed;
                }

                // Refresh the monitor bitrate
                this.setMonitorInfoLabel(scope);

                return hasChanged;
            }
            return false;
        }

        /**
         * Method to reload the thumbnail by initialize the videoFeed param in the scope and trigger the thumbnail subscription
         *
         * @param scope {IGridMonitorScope}
         */
        private async reloadThumbnail(scope: IGridMonitorScope): Promise<void> {
            await this.initVideoFeed(scope);
            this.subscribeToThumbnails(scope);
        }

        /**
         * Method to refresh the information displayed in the multi-viewer room monitors if they are not OFFLINE.
         * It will display the serviceInfo.encoding and trendingInfo.currentBitrate retrieved from the scope or error msg:
         *  - 'Source disconnected' if VideoFeedStatus != OK and not OFFLINE
         *  - 'Source mismatch' if it's source and sink at the same time
         *
         * @param scope {IGridMonitorScope} with the data to get the bitrate
         */
        private setMonitorInfoLabel(scope: IGridMonitorScope): void {
            let monitorInfoLabel: string = '';
            if (scope.videoFeed && scope.videoFeed.status !== Models.VideoFeedStatus.OFFLINE) {
                if (scope.streamId) {
                    if (scope.serviceInfo && scope.serviceInfo.encoding) {
                        monitorInfoLabel += scope.serviceInfo.encoding;
                    }
                    if (scope.trendingInfo && scope.trendingInfo.currentBitrate) {
                        monitorInfoLabel += monitorInfoLabel !== '' ? ' - ' + scope.trendingInfo.currentBitrate
                            : scope.trendingInfo.currentBitrate;
                    }
                } else if (scope.trendingInfo && scope.trendingInfo.currentBitrate) {
                    monitorInfoLabel = scope.trendingInfo.currentBitrate;
                } else {
                    // FIXME maybe? We have to look inside the videofeed to know if we have a source mismatch
                    if (Common.Utils.exists(scope.model.monitorGrid.source)) {
                        if (scope.videoFeed.status === Models.VideoFeedStatus.READY ||
                            scope.videoFeed.status === Models.VideoFeedStatus.CONNECTING ||
                            scope.videoFeed.status === Models.VideoFeedStatus.DISCONNECTING) {
                            monitorInfoLabel = 'Source disconnected';
                        } else if (scope.model.monitorGrid.source && scope.model.monitorGrid.sink) {
                            monitorInfoLabel = 'Source mismatch';
                        }
                    }
                }
            }
            scope.monitorInfoLabel = monitorInfoLabel;
        }

        /**
         * Method to store in the scope the information retrieved from the alarmsService
         *
         * @param scope {IGridMonitorScope} where the alarms information is stored
         */
        private async getAlarmsInfo(scope: IGridMonitorScope): Promise<void> {
            let promises: ng.IPromise<{}>[] = [];

            let [srcBlockHref, sinkBlockHref, srcHref, sinkHref]: string[] = this.getBlocksSimplifiedHref(scope);
            if (srcBlockHref && srcBlockHref.indexOf("null") === -1) {
                promises.push(this.alarmsService.getAlarmsInfoFromSimplifiedHref(srcBlockHref));
            }
            if (sinkBlockHref && sinkBlockHref.indexOf("null") === -1) {
                promises.push(this.alarmsService.getAlarmsInfoFromSimplifiedHref(sinkBlockHref));
            }
            if (srcHref && srcHref.indexOf("null") === -1) {
                promises.push(this.alarmsService.getAlarmsInfoFromSimplifiedHref(srcHref));
            }
            if (sinkHref && sinkHref.indexOf("null") === -1) {
                promises.push(this.alarmsService.getAlarmsInfoFromSimplifiedHref(sinkHref));
            }

            if (scope.streamPipe && (scope.model.monitorGrid.sink || (scope.model.monitorGrid.source && scope.model.monitorGrid.sink))) {
                scope.srtInPipe = scope.srtInPipe || await this.streamPipeService.getSrtInPipe(scope.streamPipe);
                scope.srtInPipe.forEach((href: string) => promises.push(this.alarmsService.getAlarmsInfoFromSimplifiedHref(href)));
            }

            this.$q.all(promises).then((devicesAlarmsInfo: Models.IAlarmsInfo[]) => {
                scope.model.alarmsInfo = {
                    currentCriticals: [],
                    allCount: 0,
                    criticalsCount: 0,
                    showAllAlarms: false,
                    showCriticalAlarms: false,
                };
                for (const deviceAlarmsInfo of devicesAlarmsInfo) {
                    // we don't want the red frame if there is not a stream active
                    if (Common.Utils.exists(scope.streamPipe)) {
                        let currentAlarms: Models.IAlarm[] = deviceAlarmsInfo.currentAlarms;
                        for (let alarm of currentAlarms) {
                            if (!alarm.confirmed && !alarm.masked && (alarm.level === 0 || alarm.level === 8)) {
                                scope.model.alarmsInfo.currentCriticals.push({
                                    alarmName: alarm.name,
                                    deviceSimplifiedHref: alarm.deviceId,
                                });
                            }
                        }
                    }
                    scope.model.alarmsInfo.allCount += deviceAlarmsInfo.allNonHidden;
                    scope.model.alarmsInfo.criticalsCount += deviceAlarmsInfo.criticalNonHidden;
                }
                scope.model.alarmsInfo.showAllAlarms = scope.model.alarmsInfo.allCount > 0 &&
                    !(scope.model.alarmsInfo.currentCriticals.length > 0) && scope.streamPipe !== undefined;
                scope.model.alarmsInfo.showCriticalAlarms = scope.model.alarmsInfo.criticalsCount > 0 &&
                    scope.model.alarmsInfo.currentCriticals.length > 0 && scope.streamPipe !== undefined;
            });
        }

        /**
         * Method to compose hrefs from parameters taken from the scope
         *
         * @param scope {IGridMonitorScope}
         * @return array with four simplified hrefs
         */
        private getBlocksSimplifiedHref(scope: IGridMonitorScope): [string, string, string, string] {
            let baseHref: string = 'networkNodes/';
            let baseHrefBlocks: string = 'blocks/';
            let srcHref: string = undefined;
            let srcBlockHref: string = undefined;
            if (scope.streamPipe && scope.streamPipe.sourceBlockId) {
                srcBlockHref = baseHrefBlocks + scope.streamPipe.sourceBlockId;
                srcHref = baseHref + scope.streamPipe.sourceNodeHref;
            } else if (scope.model && scope.model.monitorGrid && !!scope.model.monitorGrid.source) {
                srcBlockHref = baseHrefBlocks + scope.model.monitorGrid.source;
                srcHref = baseHref + scope.model.monitorGrid.sourceNode;
            }
            return [srcBlockHref, baseHrefBlocks + scope.model.monitorGrid.sink, srcHref, baseHref + scope.model.monitorGrid.sinkNode];
        }

        /**
         * Method in charge to init all the bindings. Bindings initiated:
         *  - '$destroy'
         *  - 'windowWidth' Resize event
         *  - 'stompReconnect'
         *  - 'model'
         *  - 'thumbnailLoaded'
         *  - 'thumbnail'
         *  - 'showTrending'
         *  - 'model.totalMonitorInRoom'
         *  - CREATE_OPERATION
         *  - CONFIRM_ALARM_OPERATION
         *  - BULK_CONFIRM_OPERATION
         *  - BULK_CONFIRM_ALL_OPERATION
         *  - PROBE_OPERATION
         *  - UNPROBE_OPERATION
         *  - TAKE_OPERATION
         *  - DROP_OPERATION
         *  - HEALTH_CHANGED
         *
         * @param scope {IGridMonitorScope}
         * @param element {JQuery}
         */
        private initBindings(scope: IGridMonitorScope, element: JQuery): void {
            scope.$on('$destroy', () => {
                this.$interval.cancel(scope.streamDataTimerPromise);
                this.$interval.cancel(scope.videoFeedInterval);
                this.$timeout.cancel(scope.loadingTimeout);
                this.stompService.bulkUnregister(scope.stompSubs);
                const imgTag: JQuery = $(element).find('.grid-monitor-thumbnail-source-img');
                if (imgTag.length > 0) {
                    $(imgTag).unbind('load');
                }
                if (scope.trendingInfo) {
                    scope.trendingInfo.close();
                    scope.trendingInfo = undefined;
                }
                this.unsubscribeToThumbnails(scope);
                for (const watcher of scope.watchers) {
                    watcher();
                }
                scope.stompReconnectUnsubscribe();
                scope.windowWidthUnsubscribe();
            });

            scope.windowWidthUnsubscribe = scope.$on('windowWidth', () => {
                // resize event
                scope.getContentStyle();

            });

            scope.stompReconnectUnsubscribe = this.$rootScope.$on('stompReconnect', async () => {
                this.subscribeToThumbnails(scope);
                if (scope.trendingInfo) {
                    scope.trendingInfo.closeAfterReconection();
                    scope.trendingInfo.initTrendingData();
                } else {
                    this.getTrendingData(scope);
                }
                await this.getAlarmsInfo(scope);
            });

            this.startStreamDataTimerInterval(scope);

            scope.watchers = [];
            scope.watchers.push(scope.$watch('model', async (newValue: Models.Monitor, oldValue: Models.Monitor) => {
                if (newValue !== oldValue) {
                    if (newValue.name !== oldValue.name || newValue.source !== oldValue.source) {
                        this.initData(scope);
                        await this.getData(scope);
                        await this.reloadThumbnail(scope);
                    }
                    this.startStreamDataTimerInterval(scope);
                }
            }));

            scope.watchers.push(scope.$watch('thumbnailLoaded', async (newValue: boolean, oldValue: boolean) => {
                if (newValue !== oldValue) {
                    await this.getServiceInfo(scope);
                }

            }));

            scope.bulkDebounce = false;
            scope.watchers.push(scope.$watch('thumbnail', (newVal: string, oldVal: string) => {
                const imgTag: JQuery = $(element).find('.grid-monitor-thumbnail-source-img');
                if (newVal !== oldVal && !!newVal && imgTag.length > 0) {
                    $(imgTag).bind('load', () => {
                        scope.thumbnailLoaded = true;
                    });
                }
            }));
            scope.watchers.push(scope.$watch('showTrending', (newVal: boolean, oldVal: boolean) => {
                if (newVal !== oldVal && newVal === true && scope.model.streamPipe !== undefined && !!scope.model.streamPipe.href) {
                    if (scope.trendingInfo) {
                        scope.trendingInfo.setShowTrending(newVal);
                    }
                }
            }));
            scope.watchers.push(scope.$watch('model.totalMonitorInRoom', (newVal: boolean, oldVal: boolean) => {
                if (newVal !== oldVal) {
                    this.restartCycle(scope);
                }
            }));

            scope.stompSubs = [];

            scope.stompSubs.push(
                this.stompService.register(Models.ALARMS_COMPONENT, Models.CREATE_OPERATION, async (flexEvent: Models.IFlexEvent) => {
                    const alarm: Models.Alarm = flexEvent.data as Models.Alarm;
                    const hrefs = this.getBlocksSimplifiedHref(scope);
                    if (scope.streamPipe && (scope.model.monitorGrid.sink ||
                        (scope.model.monitorGrid.source && scope.model.monitorGrid.sink))) {
                        scope.srtInPipe = scope.srtInPipe || await this.streamPipeService.getSrtInPipe(scope.streamPipe);
                    } else {
                        scope.srtInPipe = [];
                    }
                    const allHrefs = hrefs.concat(scope.srtInPipe);
                    if (allHrefs.indexOf(alarm.deviceId) > -1) {
                        await this.getAlarmsInfo(scope);
                    }
                })
            );

            scope.stompSubs.push(
                this.stompService.register(Models.FLEXO_COMPONENT, Models.CONFIRM_ALARM_OPERATION, async (flexEvent: Models.IFlexEvent) => {
                    const alarm: Models.Alarm = flexEvent.data as Models.Alarm;
                    const hrefs = this.getBlocksSimplifiedHref(scope);
                    if (scope.streamPipe &&
                        (scope.model.monitorGrid.sink || (scope.model.monitorGrid.source && scope.model.monitorGrid.sink))) {
                        scope.srtInPipe = scope.srtInPipe || await this.streamPipeService.getSrtInPipe(scope.streamPipe);
                    } else {
                        scope.srtInPipe = [];
                    }
                    const allHrefs: string[] = hrefs.concat(scope.srtInPipe);
                    if (allHrefs.indexOf(alarm.deviceId) > -1) {
                        await this.getAlarmsInfo(scope);
                    }
                })
            );

            scope.stompSubs.push(
                this.stompService.register(Models.ALARMS_COMPONENT, Models.BULK_CONFIRM_OPERATION, async (flexEvent: Models.IFlexEvent) => {
                    const bulk: { destHref: string, sourceHref: string } = flexEvent.data as { destHref: string, sourceHref: string };
                    const hrefs: string[] = this.getBlocksSimplifiedHref(scope);
                    if (scope.streamPipe && (scope.model.monitorGrid.sink ||
                        (scope.model.monitorGrid.source && scope.model.monitorGrid.sink))) {
                        scope.srtInPipe = scope.srtInPipe || await this.streamPipeService.getSrtInPipe(scope.streamPipe);
                    } else {
                        scope.srtInPipe = [];
                    }
                    const allHrefs = hrefs.concat(scope.srtInPipe);
                    if (((allHrefs.indexOf(bulk.sourceHref) > -1 || allHrefs.indexOf(bulk.destHref) > -1)) && !scope.bulkDebounce) {
                        scope.bulkDebounce = true;
                        await this.getAlarmsInfo(scope);
                        setTimeout(() => scope.bulkDebounce = false, 500);
                    }
                })
            );

            scope.stompSubs.push(
                this.stompService.register(Models.ALARMS_COMPONENT, Models.BULK_CONFIRM_ALL_OPERATION, async () => {
                    await this.getAlarmsInfo(scope);
                })
            );

            scope.stompSubs.push(
                this.stompService.register(Models.FLEXO_COMPONENT, Models.PROBE_OPERATION, (flexEvent: Models.IFlexEvent) => {
                    const block: Models.BlockWithStreamPipesBlockConnections =
                        new Models.BlockWithStreamPipesBlockConnections(flexEvent.data as Models.IBlockWithStreamPipeConnections);
                    if (this.needToUpdateVideoFeed(scope, block)) {
                        this.initVideoFeedInterval(scope);
                    }
                })
            );

            scope.stompSubs.push(
                this.stompService.register(Models.FLEXO_COMPONENT, Models.UNPROBE_OPERATION, (flexEvent: Models.IFlexEvent) => {
                    const block: Models.BlockWithStreamPipesBlockConnections =
                        new Models.BlockWithStreamPipesBlockConnections(flexEvent.data as Models.IBlockWithStreamPipeConnections);
                    if (this.needToUpdateVideoFeed(scope, block)) {
                        this.initVideoFeedInterval(scope);
                    }
                })
            );

            scope.stompSubs.push(
                this.stompService.register(Models.FLEXO_COMPONENT, Models.TAKE_OPERATION, (flexEvent: Models.IFlexEvent) => {
                    const takeEventData: Models.ITakeEventData = flexEvent.data;
                    if (this.isSourceOrSink(takeEventData.source, scope.model) || this.isSourceOrSink(takeEventData.sink, scope.model)) {
                        this.initVideoFeedInterval(scope);
                    }
                })
            );

            scope.stompSubs.push(
                this.stompService.register(Models.FLEXO_COMPONENT, Models.DROP_OPERATION, async (flexEvent: Models.IFlexEvent) => {
                    const dropEventData: Models.IDropEventData = flexEvent.data;
                    if (this.isSourceOrSink(dropEventData.source, scope.model) || this.isSourceOrSink(dropEventData.sink, scope.model)) {
                        this.initVideoFeedInterval(scope);
                    }
                })
            );

            scope.stompSubs.push(
                this.stompService.register(Models.NODE_HEALTH_COMPONENT, Models.HEALTH_CHANGED, (flexEvent: Models.IFlexEvent) => {
                    const healthCheck: Models.INodeHealth = flexEvent.data;
                    if (this.needToUpdateVideoFeedByHealth(scope, healthCheck)) {
                        this.initVideoFeedInterval(scope);
                    }
                })
            );
        }

        /**
         * Method to check if is needed to update the video feed. Used when the HEALTH_CHANGED event triggers.
         *
         * @param scope {IGridMonitorScope} with the model data
         * @param healthCheck {Models.INodeHealth} with the elementId from where we can get the elementId
         * @return {boolean} true if update needed, false otherwise
         */
        private needToUpdateVideoFeedByHealth(scope: IGridMonitorScope, healthCheck: Models.INodeHealth): boolean {
            const id: string = healthCheck.elementId.split("/")[2];
            return (scope.model.streamPipe && (scope.model.streamPipe.sourceNodeHref === id
                || scope.model.streamPipe.sinkNodeHref === id));
        }

        /**
         * Method to check if is needed to update the video feed. Used when these events trigger:
         *  - PROBE_OPERATION
         *  - UNPROBE_OPERATION
         *
         * Basically it will be needed if the block or the streamPipeBlockConnection origin/dest is source or sink
         *
         * @param scope {IGridMonitorScope} with the model data
         * @param block {Models.IBlockWithStreamPipeConnections} with the data needed to check if is source or sink
         * @return {boolean} true if update needed, false otherwise
         */
        private needToUpdateVideoFeed(scope: IGridMonitorScope, block: Models.IBlockWithStreamPipeConnections): boolean {
            if (this.isSourceOrSink(block.id, scope.model)) {
                return true;
            } else {
                if (block.streamPipeBlockConnections && block.streamPipeBlockConnections.length > 0) {
                    for (const streamPipeBlockConnection of block.streamPipeBlockConnections) {
                        if (this.isSourceOrSink(streamPipeBlockConnection.destBlockId, scope.model)
                            || this.isSourceOrSink(streamPipeBlockConnection.origBlockId, scope.model)) {
                            return true;
                        }
                    }
                }
                return false;
            }
        }

        /**
         * Method to check if a monitor belongs to a source or a sink
         *
         * @param blockId {number} with the id of the block to be checked
         * @param monitor {Models.IMonitor} with the information of the monitor source and sink
         * @return {boolean} true if source or sink, false otherwise
         */
        private isSourceOrSink(blockId: number, monitor: Models.IMonitor): boolean {
            return blockId === monitor.monitorGrid.source || blockId === monitor.monitorGrid.sink;
        }

        /**
         * Method to get the stream status and store it in the scope dataStatus
         *
         * @param scope {IGridMonitorScope} needed to check if some parameters are present and getStreamStatus in
         * case is needed
         */
        private async getServiceInfo(scope: IGridMonitorScope): Promise<void> {
            const streamHref: string = scope.streamId ? scope.streamId.toString() : undefined;
            if (!scope.serviceInfo && scope.thumbnailLoaded && streamHref) {
                try {
                    const status: Models.IStreamStatus = await this.streamStatusService.getStreamStatus(streamHref, false);
                    scope.dataStatus = status;
                    scope.serviceInfo = {};
                    if (status.status.imaliveplusplus) {
                        const options: Models.IStreamAliveData[] = status.status.imaliveplusplus.data;
                        for (const option of options) {
                            if (option.name === 'input') {
                                scope.serviceInfo.encoding = option.options[option.selected];
                            }
                        }
                    }
                } catch (e) {
                    console.error('Error while getServiceInfo: ', e);
                    scope.streamPipe = undefined;
                }
            }
        }

        /**
         * Method to set the thumbnail url according to the values retrieved from the scope.
         *
         * @param scope {IGridMonitorScope} with the values to be checked and it will set in scope.videoFeed.thumbnailUrl:
         *  - THUMBNAIL_SRC_MISMATCH_IMG if there is a source mismatch
         *  - thumbnailUrl + '?t=' + Common.Utils.getCurrentTimestamp() is the thumbnail has to be refresh
         *  - thumbnailUrl otherwise
         */
        private getThumbnailUrl(scope: IGridMonitorScope): string {
            if (scope.videoFeed && scope.videoFeed.thumbnailUrl !== '') {
                // particular case to detect source mismatch
                if (!scope.streamId && Common.Utils.exists(scope.model.monitorGrid.source) &&
                    (scope.model.monitorGrid.source && scope.model.monitorGrid.sink) && // to mismatch we must have source and sink
                    scope.videoFeed.status !== Models.VideoFeedStatus.READY &&
                    scope.videoFeed.status !== Models.VideoFeedStatus.CONNECTING &&
                    scope.videoFeed.status !== Models.VideoFeedStatus.DISCONNECTING) {
                    return GridMonitorDirective.THUMBNAIL_SRC_MISMATCH_IMG;
                } else {
                    if (scope.videoFeed.forceRefreshThumbnail) {
                        return scope.videoFeed.thumbnailUrl + '?t=' + Common.Utils.getCurrentTimestamp();
                    } else {
                        return scope.videoFeed.thumbnailUrl;
                    }
                }
            }
        }

        /**
         * Method to calculate the monitor height according to the position
         *
         * @return {number} with the monitorSelector.first().height() or 0
         */
        private calculateTrendingHeight(): number {
            const monitorSelector = $('.grid-monitor');
            const monHeight: number = monitorSelector.first() ? monitorSelector.first().height() : 0;
            return Math.floor(monHeight / 3);
        }

        /**
         * Method to get the time to refresh the data according to the number of monitors in the room
         *
         * @param scope {IGridMonitorScope} needed to get the param totalMonitorInRoom ans to set streamDataTimer
         */
        private calculateStreamDataTimer(scope: IGridMonitorScope): void {
            if (scope && scope.model && scope.model.totalMonitorInRoom) {
                //TODO: Check if there is a possible improvement here
                scope.streamDataTimer = scope.model.totalMonitorInRoom >= 12 ? 15000 : 5000;
            } else {
                scope.streamDataTimer = 5000;
            }
        }

        /**
         * Method invoked when there is a change in the number of monitors. Needed to recalculate the time to refresh the data.
         *
         * @param scope {IGridMonitorScope}
         */
        private restartCycle(scope: IGridMonitorScope): void {
            this.calculateStreamDataTimer(scope);
            this.startStreamDataTimerInterval(scope);
        }

        /**
         * Method to create an interval to refresh the data
         *
         * @param scope {IGridMonitorScope}
         */
        private startStreamDataTimerInterval(scope: IGridMonitorScope): void {
            this.$interval.cancel(scope.streamDataTimerPromise);
            scope.streamDataTimerPromise = this.$interval(async () => {
                await this.getData(scope);
            }, scope.streamDataTimer);
        }
    }
}
